import { useContext, useMemo } from 'react';

import BoardsContext from 'contexts/BoardsContext';
import ReportsContext from 'contexts/ReportsContext';
import { InsightsViewDrillTarget } from 'contextProviders/InsightsContentProvider/viewTypes';

import { buildDrillTarget } from '../insightsViewGadget';

// The popup a click on this gadget would open, named. Only dashboard gadgets
// carry a link (report gadgets filter the page instead), so this is undefined
// everywhere on a report.
const useGadgetDrillTarget = (drillDownable?: {
  reportDrillDownId?: string;
  boardDrillDownId?: string;
}): InsightsViewDrillTarget | undefined => {
  const { allReports } = useContext(ReportsContext);
  const { boards } = useContext(BoardsContext);
  const reportDrillDownId = drillDownable?.reportDrillDownId;
  const boardDrillDownId = drillDownable?.boardDrillDownId;

  return useMemo(() => {
    if (!reportDrillDownId && !boardDrillDownId) {
      return undefined;
    }
    const report = reportDrillDownId
      ? allReports.find((r) => r.id === reportDrillDownId)
      : undefined;
    const board = boardDrillDownId
      ? boards.find((b) => b.id === boardDrillDownId)
      : undefined;
    return buildDrillTarget({
      reportDrillDownId,
      boardDrillDownId,
      reportNamesById: report ? { [report.id]: report.name } : {},
      boardNamesById: board ? { [board.id]: board.name } : {},
    });
  }, [reportDrillDownId, boardDrillDownId, allReports, boards]);
};

export default useGadgetDrillTarget;
